<template>
  <div class="antv-chart-mini">
    <div class="chart-wrapper" :style="{ height: 46 }">
      <v-chart 
        :forceFit="true" 
        :height="height" 
        :data="data" 
        :scale="scale"
        :padding="[36, 0, 18, 0]"
      >
        <v-tooltip/>
        <v-smooth-area position="x*y" />
      </v-chart>
    </div>
  </div>
</template>

<script>

const scale = [{ dataKey: 'x' }, { dataKey: 'y' }]

export default {
  name: 'MiniArea',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    scale: {
      type: Array,
      default: () => scale
    }
  },
  data () {
    return {
      height: 100
    }
  }
}
</script>

<style lang="less" scoped>
  @import "chart";
</style>
